export const quickAnswer =
  'Choose one ability per combat group, save your plan in this browser, and copy a URL to share it. No account or game-save connection is needed.';
export const sourceIds = ['gamesradar-abilities', 'ps-ngplus'];
export const related = [
  '/abilities/barrage-vs-volatile-anomaly-vs-shield',
  '/abilities/ground-slam-vs-push',
  '/abilities/ignite-vs-inferno',
];

## How the Planner Works

Choose an option in each group. Clear removes one group's choice; Reset All clears this browser's saved plan. A shared URL restores the listed choices, replacing the locally saved plan for that view.

The planner records a set of choices. It does not calculate damage, track your unlocks, equip abilities in-game or model the additional post-story combat choice.

## Combat Ability Choices

Artist, Dancer, Deserter, Collective and Physicist each offer alternatives. Command is a fixed unlock. The summary's tags describe broad styles, not measured build performance.

## What Carries into New Game Plus

Combat abilities, talents, artifacts, Aberrant upgrades and health/resource improvements carry over. Traversal abilities remain tied to the story. NG+ permits combinations beyond this planner's one-option-per-group model.

## How Respec Works

In-game, the mural in The Gap lets you reset combat choices using a Reset Item. Resetting this website does not consume a game item.

## Related Ability Comparisons

Compare [Artist choices](/abilities/barrage-vs-volatile-anomaly-vs-shield), [Ground Slam and Push](/abilities/ground-slam-vs-push), or [Ignite and Inferno](/abilities/ignite-vs-inferno) before finalizing your plan.
